<template>
  <div id="app">
    <Navbar />
    <div class="spacer" />
    <router-view />
    <div class="spacer" />
    <div id="footer">
      All content copyright MIT automotive 2019
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style lang="postcss">
  @import './assets/css/lost.css';
  @import './assets/css/style.css';
  @import './assets/css/pc.css';
  @import './assets/css/mobile.css';
</style>



// WEBPACK FOOTER //
// src/App.vue